module.exports = {"svg":{"$":{"t":"1536661573676","class":"icon","style":"","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"3291","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"200","height":"200"},"defs":[{"style":[{"$":{"type":"text/css"}}]}],"path":[{"$":{"d":"M364.899556 1024l-91.576889-91.576889L693.745778 512 273.322667 91.576889 364.899556 0l512 512z","p-id":"3292"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/next.svg
// module id = Ng1+
// module chunks = 125